import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles(() => ({
  form: {},

  alignRight: {
    textAlign: 'right',
    marginTop: 12,

    '& button:first-child': {
      marginRight: 8,
    },
  },

  contentInput: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },

  pre: {
    outline: '1px solid #ccc',
    padding: '12px',
    background: '#f3f3f3',
    borderRadius: '4px',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    hyphens: 'auto',
    marginTop: 12,
  },
  urlSuccess: {
    color: '#009358',
    paddingTop: 10,
  },
  urlError: {
    color: '#dc3f53',
    paddingTop: 10,
  },
  paddingMsg: {
    paddingTop: 10,
  },
  alert: {
    boxShadow: 'none',
    fontSize: 14,
  },
  item: {
    display: 'flex',
    marginBottom: 12,
  },
  status: {
    marginLeft: 6,
  },
}));

export default styles;
